var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5780_13068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.03906 8.66703C2.20267 10.1296 2.89812 11.4811 3.99315 12.4643C5.08818 13.4476 6.50641 13.9941 7.9781 14C9.4498 14.0058 10.8723 13.4705 11.9751 12.496C13.0779 11.5214 13.784 10.1755 13.9592 8.71425C14.1344 7.25301 13.7664 5.77834 12.9253 4.57071C12.0841 3.36307 10.8285 2.50671 9.39709 2.16448C7.96572 1.82226 6.4585 2.01804 5.16207 2.7146C3.86564 3.41116 2.87044 4.55991 2.36573 5.94236",
    stroke: "#C44141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2.66797V6.0013H5.33333",
    stroke: "#C44141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 7.9987C7.33398 8.17551 7.40422 8.34508 7.52925 8.4701C7.65427 8.59513 7.82384 8.66536 8.00065 8.66536C8.17746 8.66536 8.34703 8.59513 8.47206 8.4701C8.59708 8.34508 8.66732 8.17551 8.66732 7.9987C8.66732 7.82189 8.59708 7.65232 8.47206 7.52729C8.34703 7.40227 8.17746 7.33203 8.00065 7.33203C7.82384 7.33203 7.65427 7.40227 7.52925 7.52729C7.40422 7.65232 7.33398 7.82189 7.33398 7.9987Z",
    stroke: "#C44141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5780_13068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.3fb3dfd46e54767efae0da46ffcaa2d3.svg";
export { ForwardRef as ReactComponent };